import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=f3acf63c&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=f3acf63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3acf63c",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/navigation_bar.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FNavigationBar.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports